// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "user/v1/user.proto" (package "user.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private user RPCs and protos
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message user.v1.OrganizationSummary
 */
export interface OrganizationSummary {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string public_namespace = 3;
     */
    publicNamespace: string;
}
/**
 * @generated from protobuf message user.v1.ListAllOrganizationsRequest
 */
export interface ListAllOrganizationsRequest {
    /**
     * Optional. Matches against organization name, public namespace, or ID. Empty
     * returns all organizations.
     *
     * @generated from protobuf field: string search = 1;
     */
    search: string;
    /**
     * @generated from protobuf field: int64 limit = 2;
     */
    limit: string;
    /**
     * @generated from protobuf field: int64 offset = 3;
     */
    offset: string;
}
/**
 * @generated from protobuf message user.v1.ListAllOrganizationsResponse
 */
export interface ListAllOrganizationsResponse {
    /**
     * @generated from protobuf field: repeated user.v1.OrganizationSummary organizations = 1;
     */
    organizations: OrganizationSummary[];
}
/**
 * @generated from protobuf message user.v1.AddRoleWithoutApprovalRequest
 */
export interface AddRoleWithoutApprovalRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message user.v1.AddRoleWithoutApprovalResponse
 */
export interface AddRoleWithoutApprovalResponse {
}
/**
 * @generated from protobuf message user.v1.User
 */
export interface User {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: repeated string emails = 2;
     */
    emails: string[];
    /**
     * @generated from protobuf field: map<string, google.protobuf.Timestamp> org_last_access = 4;
     */
    orgLastAccess: {
        [key: string]: Timestamp;
    };
    /**
     * @generated from protobuf field: bool is_org_admin = 5;
     */
    isOrgAdmin: boolean;
}
/**
 * @generated from protobuf message user.v1.GetAppUserRequest
 */
export interface GetAppUserRequest {
}
/**
 * @generated from protobuf message user.v1.GetAppUserResponse
 */
export interface GetAppUserResponse {
    /**
     * @generated from protobuf field: user.v1.User user = 1;
     */
    user?: User;
}
/**
 * @generated from protobuf message user.v1.SetUserOrgLastAccessRequest
 */
export interface SetUserOrgLastAccessRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message user.v1.SetUserOrgLastAccessResponse
 */
export interface SetUserOrgLastAccessResponse {
}
/**
 * @generated from protobuf message user.v1.UserInvite
 */
export interface UserInvite {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string organization_name = 3;
     */
    organizationName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 4;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: string role = 5;
     */
    role: string;
}
/**
 * @generated from protobuf message user.v1.GetUserInvitesRequest
 */
export interface GetUserInvitesRequest {
}
/**
 * @generated from protobuf message user.v1.GetUserInvitesResponse
 */
export interface GetUserInvitesResponse {
    /**
     * @generated from protobuf field: repeated user.v1.UserInvite invites = 1;
     */
    invites: UserInvite[];
}
/**
 * @generated from protobuf message user.v1.AcceptOrganizationInviteRequest
 */
export interface AcceptOrganizationInviteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message user.v1.AcceptOrganizationInviteResponse
 */
export interface AcceptOrganizationInviteResponse {
}
/**
 * @generated from protobuf message user.v1.DeclineOrganizationInviteRequest
 */
export interface DeclineOrganizationInviteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message user.v1.DeclineOrganizationInviteResponse
 */
export interface DeclineOrganizationInviteResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationSummary$Type extends MessageType<OrganizationSummary> {
    constructor() {
        super("user.v1.OrganizationSummary", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "public_namespace", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.OrganizationSummary
 */
export const OrganizationSummary = new OrganizationSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAllOrganizationsRequest$Type extends MessageType<ListAllOrganizationsRequest> {
    constructor() {
        super("user.v1.ListAllOrganizationsRequest", [
            { no: 1, name: "search", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "limit", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.ListAllOrganizationsRequest
 */
export const ListAllOrganizationsRequest = new ListAllOrganizationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAllOrganizationsResponse$Type extends MessageType<ListAllOrganizationsResponse> {
    constructor() {
        super("user.v1.ListAllOrganizationsResponse", [
            { no: 1, name: "organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.ListAllOrganizationsResponse
 */
export const ListAllOrganizationsResponse = new ListAllOrganizationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddRoleWithoutApprovalRequest$Type extends MessageType<AddRoleWithoutApprovalRequest> {
    constructor() {
        super("user.v1.AddRoleWithoutApprovalRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.AddRoleWithoutApprovalRequest
 */
export const AddRoleWithoutApprovalRequest = new AddRoleWithoutApprovalRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddRoleWithoutApprovalResponse$Type extends MessageType<AddRoleWithoutApprovalResponse> {
    constructor() {
        super("user.v1.AddRoleWithoutApprovalResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.AddRoleWithoutApprovalResponse
 */
export const AddRoleWithoutApprovalResponse = new AddRoleWithoutApprovalResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class User$Type extends MessageType<User> {
    constructor() {
        super("user.v1.User", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "org_last_access", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Timestamp } },
            { no: 5, name: "is_org_admin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.User
 */
export const User = new User$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppUserRequest$Type extends MessageType<GetAppUserRequest> {
    constructor() {
        super("user.v1.GetAppUserRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.GetAppUserRequest
 */
export const GetAppUserRequest = new GetAppUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppUserResponse$Type extends MessageType<GetAppUserResponse> {
    constructor() {
        super("user.v1.GetAppUserResponse", [
            { no: 1, name: "user", kind: "message", T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.GetAppUserResponse
 */
export const GetAppUserResponse = new GetAppUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserOrgLastAccessRequest$Type extends MessageType<SetUserOrgLastAccessRequest> {
    constructor() {
        super("user.v1.SetUserOrgLastAccessRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.SetUserOrgLastAccessRequest
 */
export const SetUserOrgLastAccessRequest = new SetUserOrgLastAccessRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserOrgLastAccessResponse$Type extends MessageType<SetUserOrgLastAccessResponse> {
    constructor() {
        super("user.v1.SetUserOrgLastAccessResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.SetUserOrgLastAccessResponse
 */
export const SetUserOrgLastAccessResponse = new SetUserOrgLastAccessResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserInvite$Type extends MessageType<UserInvite> {
    constructor() {
        super("user.v1.UserInvite", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "organization_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 5, name: "role", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.UserInvite
 */
export const UserInvite = new UserInvite$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserInvitesRequest$Type extends MessageType<GetUserInvitesRequest> {
    constructor() {
        super("user.v1.GetUserInvitesRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.GetUserInvitesRequest
 */
export const GetUserInvitesRequest = new GetUserInvitesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserInvitesResponse$Type extends MessageType<GetUserInvitesResponse> {
    constructor() {
        super("user.v1.GetUserInvitesResponse", [
            { no: 1, name: "invites", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserInvite }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.GetUserInvitesResponse
 */
export const GetUserInvitesResponse = new GetUserInvitesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcceptOrganizationInviteRequest$Type extends MessageType<AcceptOrganizationInviteRequest> {
    constructor() {
        super("user.v1.AcceptOrganizationInviteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.AcceptOrganizationInviteRequest
 */
export const AcceptOrganizationInviteRequest = new AcceptOrganizationInviteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcceptOrganizationInviteResponse$Type extends MessageType<AcceptOrganizationInviteResponse> {
    constructor() {
        super("user.v1.AcceptOrganizationInviteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.AcceptOrganizationInviteResponse
 */
export const AcceptOrganizationInviteResponse = new AcceptOrganizationInviteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeclineOrganizationInviteRequest$Type extends MessageType<DeclineOrganizationInviteRequest> {
    constructor() {
        super("user.v1.DeclineOrganizationInviteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.DeclineOrganizationInviteRequest
 */
export const DeclineOrganizationInviteRequest = new DeclineOrganizationInviteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeclineOrganizationInviteResponse$Type extends MessageType<DeclineOrganizationInviteResponse> {
    constructor() {
        super("user.v1.DeclineOrganizationInviteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message user.v1.DeclineOrganizationInviteResponse
 */
export const DeclineOrganizationInviteResponse = new DeclineOrganizationInviteResponse$Type();
/**
 * @generated ServiceType for protobuf service user.v1.InternalUserService
 */
export const InternalUserService = new ServiceType("user.v1.InternalUserService", [
    { name: "GetAppUser", options: {}, I: GetAppUserRequest, O: GetAppUserResponse },
    { name: "SetUserOrgLastAccess", options: {}, I: SetUserOrgLastAccessRequest, O: SetUserOrgLastAccessResponse },
    { name: "ListAllOrganizations", options: {}, I: ListAllOrganizationsRequest, O: ListAllOrganizationsResponse },
    { name: "AddRoleWithoutApproval", options: {}, I: AddRoleWithoutApprovalRequest, O: AddRoleWithoutApprovalResponse },
    { name: "GetUserInvites", options: {}, I: GetUserInvitesRequest, O: GetUserInvitesResponse },
    { name: "AcceptOrganizationInvite", options: {}, I: AcceptOrganizationInviteRequest, O: AcceptOrganizationInviteResponse },
    { name: "DeclineOrganizationInvite", options: {}, I: DeclineOrganizationInviteRequest, O: DeclineOrganizationInviteResponse }
]);
